import React, { useEffect } from 'react'

function VerifyScreen() {
    useEffect(()=>{
        window.opener.postMessage({message: window.location.origin}, window.location.origin);
    },[])
  return (
    <div>Verify</div>
  )
}

export default VerifyScreen